<template>
  <div>
    <h1 class="page_title">导出日志</h1>
    <div class="filter-container">
      <el-date-picker v-model="dateRange"
                      type="daterange"
                      size="mini"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="datePickerOption"
                      value-format="yyyy-MM-dd"></el-date-picker>
      <el-button size="small"
                 icon="el-icon-search"
                 class="filter-item"
                 @click="getList">筛选</el-button>
      <el-button size="small"
                 class="filter-item"
                 icon="el-icon-refresh"
                 @click="reset">重置</el-button>
    </div>
    <el-table :data="tableRecords"
              stripe>
      <el-table-column align="left"
                       label="操作时间"
                       width="200">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}')}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       label="导出任务"
                       min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.exportName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left"
                       label="操作人员"
                       width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.userName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="left"
                       label="导出数量"
                       width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.recordTotal}}条</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="listQuery.page"
                     :page-sizes="[10,20,30,50]"
                     :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { parseTime } from '../../filters/index'
export default {
  data() {
    return {
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      tableRecords: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨日',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      dateRange: [
        parseTime(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          '{y}-{m}-{d}'
        ),
        parseTime(new Date(), '{y}-{m}-{d}'),
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  methods: {
    reset() {
      this.listQuery.page = 1
      this.dateRange = [
        parseTime(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          '{y}-{m}-{d}'
        ),
        parseTime(new Date(), '{y}-{m}-{d}'),
      ]
      this.getList()
    },
    getList() {
      var parent = this
      this.$httpAuth
        .post('v2/appDealerManagerService/exportRecords', {
          dealerId: this.dealer.dealerId,
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          createdDate: {
            start: this.dateRange != null ? this.dateRange[0] : '',
            end: this.dateRange != null ? this.dateRange[1] : '',
          },
        })
        .then(function (response) {
          parent.tableRecords = response.data.data
          parent.total = response.data.total
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>
